import { createActionGroup, emptyProps, props } from '@ngrx/store';

export const MesEtablissementSearchFormActions = createActionGroup({
  source: 'Mes Etablissements Search Component',
  events: {
    noActions: emptyProps(),
    resetSearchForm: emptyProps(),
    updateSearchForm: props<{ form: any }>(),
    resetDone: props<{ resetDone: boolean }>(),
    updateSort: props<{ orderBy: string; orderByColumn: string }>(),
  },
});
